package de.oevbs.kunde.kundenportal2.services.mydata

import de.oevbs.businesspartner.bpcrmservice2.bankaccount.model.BankAccount
import de.oevbs.kunde.kundenportal2.GeneralProgressStep
import de.oevbs.kunde.kundenportal2.authentication.PortalSessionMiddleware
import de.oevbs.kunde.kundenportal2.components.GlobalServiceMessagesStore
import de.oevbs.kunde.kundenportal2.components.globalSubmitTracker
import de.oevbs.kunde.kundenportal2.model.services.mydata.validation
import de.oevbs.kunde.kundenportal2.util.tryCatchAndHandleErrors
import de.oevbs.sfa.communication.use
import dev.fritz2.core.EmittingHandler
import dev.fritz2.headless.validation.ComponentValidationMessage
import dev.fritz2.validation.ValidatingStore
import dev.fritz2.validation.valid
import kotlinx.coroutines.Job

class BankAccountStore(initialData: BankAccount, listStore: BankAccountsStore, job: Job) :
    ValidatingStore<BankAccount, Unit, ComponentValidationMessage>(
        initialData,
        validation = BankAccount.validation,
        metadataDefault = Unit,
        job,
        validateAfterUpdate = true
    ) {

    init {
        validate(current, Unit)
    }

    private val client = MyDataClient().use(PortalSessionMiddleware)

    val submitChangeBankAccountRequestIfValid: EmittingHandler<Unit, Boolean> = handleAndEmit { currentModel ->
        GlobalServiceMessagesStore.clear(Unit)

        if (!validate(currentModel, Unit).valid) {
            return@handleAndEmit currentModel
        }

        val success = globalSubmitTracker.track {
            changeBankAccount(currentModel)
        }
        if (success) {
            listStore.progress.update(GeneralProgressStep.SUCCESS2)
            listStore.lastChangedBankAccount.update(currentModel)
        } else {
            listStore.lastChangedBankAccount.update(null)
        }

        emit(success)
        currentModel
    }

    private suspend fun changeBankAccount(bankAccount: BankAccount): Boolean {
        tryCatchAndHandleErrors("Speichern der Bankdaten") {
             client.saveBankData(bankAccount)
        } ?: return false

        return true
    }
}